const contactCardTemplate = document.createElement('template')
contactCardTemplate.innerHTML = `

  <div class='card h-100 card-ansprechpartner'>
    <div class='card-img'>
      <img src="" class="img-fluid card-img-top js-contact-image" /><br>
    </div>

    <div class='card-body'>
      <div class='card-title'>
        <h5 class="js-contact-name"></h5>
      </div>
      <p class='card-text small'>
        <span class="js-contact-occupation"></span><br />
        <span class="js-contact-position"></span><br />
        <span class="js-contact-place"></span>
      </p>
      <div class='card-links'>

        <a href="tel:" data-toggle='tooltip' class="tel-person">
          <span class='svg-icon'>
            <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'>
              <path
                d='M26,29h-.17C6.18,27.87,3.39,11.29,3,6.23A3,3,0,0,1,5.76,3h5.51a2,2,0,0,1,1.86,1.26L14.65,8a2,2,0,0,1-.44,2.16l-2.13,2.15a9.37,9.37,0,0,0,7.58,7.6l2.17-2.15A2,2,0,0,1,24,17.35l3.77,1.51A2,2,0,0,1,29,20.72V26A3,3,0,0,1,26,29ZM6,5A1,1,0,0,0,5,6v.08C5.46,12,8.41,26,25.94,27A1,1,0,0,0,27,26.06V20.72l-3.77-1.51-2.87,2.85L19.88,22C11.18,20.91,10,12.21,10,12.12l-.06-.48,2.84-2.87L11.28,5Z'
                transform='translate(0)'></path>
            </svg>
          </span>
          <span class='tooltiptext js-contact-phone'></span>
        </a>

        <a href="tel:" class="mobile-person" data-toggle='tooltip'>
          <span class='svg-icon'>
            <svg xmlns='http://www.w3.org/2000/svg' width='32' height='32' viewBox='0 0 32 32'>
              <path
                d='M14,0H2A2,2,0,0,0,0,2V24a2,2,0,0,0,2,2H14a2,2,0,0,0,2-2V2a2,2,0,0,0-2-2Zm0,2V4H2V2ZM2,24V6H14V24Z'
                transform='translate(24 30) rotate(180)'></path>

            </svg>
          </span>
          <span class='tooltiptext js-contact-mobile'></span>
        </a>


        <a class="mailto-person" href="mailto:" data-toggle='tooltip'>
          <span class='svg-icon gradient'>
            <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'>
              <path
                d='M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM25.8,8,16,14.78,6.2,8ZM4,24V8.91l11.43,7.91a1,1,0,0,0,1.14,0L28,8.91V24Z'
                transform='translate(0)'></path>

            </svg>
          </span>
          <span class='tooltiptext js-contact-email'></span>
        </a>

      </div>
    </div>
  </div>

`

class ContactCard extends HTMLElement {
  constructor(
    name: string,
    photo: string,
    occupation: string,
    position: string,
    place: string,
    mobile: string,
    phone: string,
    email: string
  ) {
    super()
    this.appendChild(contactCardTemplate.content.cloneNode(true))
    this.classList.add(
      'col-xxl-3',
      'col-xl-6',
      'col-xs-12',
      'mb-5',
      'contact-card'
    )

    const contactName = this.querySelector('.js-contact-name') as HTMLElement
    const contactImage = this.querySelector(
      '.js-contact-image'
    ) as HTMLImageElement
    const contactOccupation = this.querySelector(
      '.js-contact-occupation'
    ) as HTMLElement
    const contactPosition = this.querySelector(
      '.js-contact-position'
    ) as HTMLElement
    const contactPlace = this.querySelector('.js-contact-place') as HTMLElement
    const contactMobile = this.querySelector(
      '.js-contact-mobile'
    ) as HTMLElement
    const contactMobileTel = this.querySelector(
      '.mobile-person'
    ) as HTMLAnchorElement
    const contactPhone = this.querySelector('.js-contact-phone') as HTMLElement
    const contactPhoneTel = this.querySelector(
      '.tel-person'
    ) as HTMLAnchorElement
    const contactEmail = this.querySelector('.js-contact-email') as HTMLElement
    const contactMailTo = this.querySelector(
      '.mailto-person'
    ) as HTMLAnchorElement
    contactName
      ? (contactName.innerText = this.getAttribute('name') || name)
      : null
    contactImage
      ? (contactImage.src = this.getAttribute('photo') || photo)
      : null
    contactOccupation
      ? (contactOccupation.innerText =
          this.getAttribute('occupation') || occupation)
      : null
    contactPosition
      ? (contactPosition.innerText = this.getAttribute('position') || position)
      : null
    contactPlace
      ? (contactPlace.innerText = this.getAttribute('place') || place)
      : null
    if (this.getAttribute('mobile') || mobile) {
      contactMobileTel
        ? (contactMobileTel.href =
            'tel:' +
            (this.getAttribute('mobile') || mobile).replace(/\s+/g, ''))
        : null
      contactMobile
        ? (contactMobile.innerText = this.getAttribute('mobile') || mobile)
        : null
    } else {
      contactMobile
        ? (contactMobile.parentElement!.style.display = 'none')
        : null
    }
    if (this.getAttribute('phone') || phone) {
      contactPhoneTel
        ? (contactPhoneTel.href =
            'tel:' + (this.getAttribute('phone') || phone).replace(/\s+/g, ''))
        : null
      contactPhone
        ? (contactPhone.innerText = this.getAttribute('phone') || phone)
        : null
    } else {
      contactPhone ? (contactPhone.parentElement!.style.display = 'none') : null
    }
    if (this.getAttribute('email') || email) {
      contactMailTo
        ? (contactMailTo.href =
            'mailto:' + (this.getAttribute('email') || email))
        : null
      contactEmail
        ? (contactEmail.innerText = this.getAttribute('email') || email)
        : null
    } else {
      contactEmail ? (contactEmail.parentElement!.style.display = 'none') : null
    }
  }
  connectedCallback() {
    this.render()
    const tooltipEls = document.querySelectorAll('.tooltiptext')

    tooltipEls.forEach(function (tooltipEl) {
      tooltipEl.addEventListener('click', function (event) {
        event.stopPropagation()
        event.preventDefault()

        const tooltipText = tooltipEl.innerText

        navigator.clipboard.writeText(tooltipText).then(
          function () {
            tooltipEl.innerText = 'Text kopiert'
          },
          function (error) {
            tooltipEl.innerText = 'Fehler beim kopieren'
          }
        )
      })
    })

    const anchorEls = document.querySelectorAll('a')

    anchorEls.forEach(function (anchorEl) {
      anchorEl.addEventListener('click', function (event) {
        const tooltipEl = anchorEl.querySelector('.tooltiptext')

        if (tooltipEl && tooltipEl.contains(event.target)) {
          event.preventDefault()
        }
      })
    })
  }

  render() {}
}

export default ContactCard
